import React from 'react';

const Skill = (props) => {
    let bgColor = '';
    if(props.porcentaje <= 33) {
        bgColor = '#C16C56';
    } else if(props.porcentaje <= 66) {
        bgColor = '#AAC156';
    } else {
        bgColor = '#56aac1';
    }

    return (
        <div className="mi-progress">
            <p className="mi-progress-title h6">{props.nombre}</p>
            <div className="mi-progress-inner">
                <div className="mi-progress-percentage" style={{color: bgColor}}>{props.nivel}</div>
                <div className="mi-progress-container">
                    <span
                      className="mi-progress-active"
                      style={props.isVisible ? {
                          width: `${props.porcentaje}%`,
                          backgroundColor: bgColor
                        } : {
                            width: `${props.porcentaje}%`,
                            backgroundColor: bgColor
                        }}
                    ></span>
                </div>
            </div>
        </div>
    );
}
 
export default Skill;